var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7771 4.51836C22.0743 4.80936 22.0743 5.28116 21.7771 5.57216L7.56812 19.4816C7.27085 19.7726 6.78889 19.7726 6.49163 19.4816C6.19436 19.1906 6.19436 18.7188 6.49163 18.4278L20.7006 4.51836C20.9978 4.22736 21.4798 4.22736 21.7771 4.51836Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.0194V14.9806C5 15.7384 5.43335 16.3971 6.07069 16.7323L18.194 4.86446V3.99529C18.194 3.18717 17.2609 2.71711 16.5892 3.18681L11.6189 6.66221C11.2746 6.90293 10.8621 7.03233 10.4391 7.03233H7.02985C5.9088 7.03233 5 7.92197 5 9.0194Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.194 20.0047C18.194 20.8128 17.2609 21.2829 16.5892 20.8132L11.7893 17.457L18.194 11.1873V20.0047Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMute);
export default __webpack_public_path__ + "static/media/volume-mute.a340004dc7278149957e2a714bfa94a6.svg";
export { ForwardRef as ReactComponent };